import { StarRating } from '../TransactionRequest/StarRating';
import { LiaTimesSolid } from 'react-icons/lia';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../ContextAuth/Context';
import axios from 'axios';
import { LoadingMode } from '../Components/LoadingMode';
import { getToken } from '../utils';

function ModalRateLoyaltyview({ content }) {
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(null);

  const { token: userToken } = getToken();

  const { handleOpenandCloseModal, handleToast } = content;
  const handleChange = (e) => {
    setReview(e.target.value);
  };

  const handleSubmitRating = () => {
    setIsSubmiting(true);
  };

  useEffect(() => {
    const data = {
      rated_user_id: 0,
      star: rating,
      review: review,
      cx_id: null,
    };

    let cancel = true;
    if (isSubmiting) {
      const privacyPolicie = async () => {
        const url = 'https://apex.loyaltyview.com/api/rating/store';
        try {
          const response = await axios.post(url, data, {
            headers: { Authorization: `Bearer ${userToken}` },
          });
          setReview('');
          setRating(null);
          handleToast('success', 'Rating successfull');
          setIsSubmiting(false);
          handleOpenandCloseModal('close');
          console.log('note:', response.data);
        } catch (error) {
          console.log(error);
          setReview('');
          setRating(null);
          handleToast('error', 'An error occured please try again');
          setIsSubmiting(false);
        }
      };
      privacyPolicie();
    }
    return () => {
      cancel = false;
    };
  }, [userToken, isSubmiting]);

  return (
    <article className='absolute rounded top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-p-wh py-8 w-[25rem]'>
      <h2 className='px-6 border-b-hf pb-2 text[18px] font-semibold'>
        Rate Loyaltyview
      </h2>
      <span
        className=' text-2xl text-s-bk cursor-pointer fixed right-6 top-6 hover:text-p-bk'
        onClick={() => handleOpenandCloseModal('close')}
      >
        <LiaTimesSolid />
      </span>
      <div className='px-6 mt-6'>
        <StarRating data={{ rating, setRating }} />
        <input
          type='text'
          value={review}
          onChange={handleChange}
          className='px-2 h-11 border-hf mt-4 mb-8 font-light w-full'
          placeholder='Review:'
        />
        <button
          type='button'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 h-fit py-2 w-full disabled:bg-b-mct bg-b-mc rounded relative'
          onClick={handleSubmitRating}
          disabled={isSubmiting}
        >
          Submit
          {isSubmiting && <LoadingMode />}
        </button>
      </div>
    </article>
  );
}

export default ModalRateLoyaltyview;
